import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_switch.scss'

import { Props, InputAttributes } from '../utils/types'

export interface SwitchProps extends Props {
  checked?: boolean
  disabled?: boolean
}

const cx = bind(styles)

export const Switch = React.forwardRef<
  HTMLInputElement,
  InputAttributes & SwitchProps
>(({ checked = false, className, disabled = false, ...props }, ref) => (
  <label
    className={cx(
      'core-switch',
      {
        'core-switch--disabled': disabled,
      },
      className
    )}
  >
    <input
      {...props}
      checked={checked}
      disabled={disabled}
      ref={ref}
      type="checkbox"
    />
    <span className={cx('core-switch__slider', className)} />
  </label>
))

Switch.displayName = 'Switch'

export default Switch
